<template>
    <div class="page-wrapper page register">
        <div class="page-grid-wrapper standardPage">
            <div class="page-grid-fix">
                <article class="grid-container columns-two tick">
                    <section class="section1">
                        <div class="login-register">
                            <p>Already a member? 
                                <router-link to="/login">Login here</router-link>
                            </p>
                        </div>
                        <h1>Register</h1>
                    </section>
                    <section class="section2">
                            <p class="vhtml" v-html=content.Description></p>
                    </section> 
                    <section class="section3">
                        <h3>Register</h3>
                        <RegisterForm class="p-5 bg-white border rounded shadow" />
                </section>
            </article>
        </div>                   

    </div>
</div>
</template>

<script>
import RegisterForm from "../components/RegisterForm";

export default {
    name: "RegisterView",
    components: {
        RegisterForm

    },
  data() {
      return {
        content: {},
	    activeItem: 'login',
        showRoute: {
            showRoute : this.$route.name
           }
        }
    },
    mounted() {
        this.getContent();
        // Emit to parent that this page is loaded and App.vue can hide loader
    this.$emit("route-data-ready");
    },

    watch: {
        '$route.name': function () {
            this.showRoute = this.$route.name;
        },    
    },
    created() {
    this.showRoute = this.$route.name
    
},  
  methods: {
      getContent(address) {
           this.$axios.get(address ? address : "/api/membership" ).then(response => {
              console.log(response.data.data[0]);
            this.content = response.data.data[0];
            
          });
        },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    }
  }
};

</script>